import Api from "../../../https/Api";
import { IUser } from "../../../utils/UserInterfaces";

export class ProfilService {
  private api;
  constructor() {
    this.api = new Api();
  }

  //get
  async getAllDestination(){
      return this.api.get('destinations');
  }
  async getUserById(userId: string) {
    return this.api.simpleGet("users/get", userId);
  }

  async updateUser(id:string, user: IUser){
    return this.api.postById('users', id, user);
    // return this.api.postFormDataById('users',id, user)
  }

  reSendValidationCode(data:{userId:string, userPhone:string, userCountry: string}){
      return this.api.put('user/resend-sms-code-validation',data)
  }

  confirmCodeValidation(userId:string){
      const data={
          userId
      }
      return this.api.put('user/code-validation-update',data)
  }

  
  async uploadAvatar(userId:string, avatar: File){
    return this.api.postById('users', userId, avatar);
  }
}
